<template>
  <div>
    <provider-search-result-item
      v-for="(item, i) in items"
      :key="i"
      class="my-3"
      :data="item"
    />

    <pagination
      v-if="showPagination"
      :data="pagination"
      @pagination-go-page="pageChanged"
    />
    <result-not-found v-if="data.searched !== false && data.count === 0" />
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination';
import ProviderSearchResultItem from './ProviderSearchResultItem';
import ResultNotFound from '@/components/common/ResultNotFound';

export default {
  name: 'ProviderSearchResult',
  components: {
    Pagination,
    ProviderSearchResultItem,
    ResultNotFound,
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        data: [],
        count: 0,
        pageCount: 0,
        currentPage: 0,
        totalItemCount: 0,
      }),
    },
  },
  computed: {
    items() {
      return this.data.data || [];
    },
    pagination() {
      return {
        count: this.data.count,
        pageCount: this.data.pageCount,
        currentPage: this.data.currentPage,
        totalItemCount: this.data.totalItemCount,
      };
    },
    showPagination() {
      return this.data.totalItemCount > 10;
    },
  },
  methods: {
    pageChanged(page) {
      this.$emit('page-changed', page);
    },
  },
};
</script>
